// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__1c86z","thumbnails":"styles_thumbnails__DEeDB","carousel":"styles_carousel__V2v5j","avatar":"styles_avatar__x9WSj","current":"styles_current__24tTm"};